import type { FC } from 'react';
import { Tabs, type TabsProps, type FormInstance } from 'antd';
import { useParams } from 'react-router-dom';
import type { MeterModelFormValues } from '../types';
import { MeterModelOverviewTab } from '@/routes/reseller-data/routes/model-library/routes/models/routes/detail/route/overview/Content';
import { MetersTab } from '@/routes/reseller-data/routes/model-library/routes/models/routes/detail/route/meters/Content';
import { METER_MODEL_TABS_TRANSLATED, MeterModelTab } from '@/routes/reseller-data/routes/model-library/const';

const { TabPane } = Tabs;

interface MeterModelTabsProps {
  onTabChange: TabsProps['onChange'];
  form: FormInstance<MeterModelFormValues>;
  setIsFormChanged: (changed: boolean) => void;
}

export const MeterModelTabs: FC<MeterModelTabsProps> = ({ onTabChange, form, setIsFormChanged }) => {
  const { tab } = useParams<{ tab: string }>();

  return (
    <Tabs
      destroyOnHidden
      activeKey={tab}
      tabBarStyle={{ paddingLeft: 24, backgroundColor: 'white' }}
      onChange={onTabChange}
    >
      <TabPane key={MeterModelTab.Overview} tab={METER_MODEL_TABS_TRANSLATED[MeterModelTab.Overview]}>
        <MeterModelOverviewTab form={form} setIsFormChanged={setIsFormChanged} />
      </TabPane>
      <TabPane key={MeterModelTab.Meters} tab={METER_MODEL_TABS_TRANSLATED[MeterModelTab.Meters]}>
        <MetersTab />
      </TabPane>
    </Tabs>
  );
};
